<template>
     <div></div>
</template>

<script>
export default{
  mounted(){
    var isSet = false
    var inteval = setInterval(function() {
      var search = location.search.replace('?', '')
      if (isSet) {
          clearInterval(inteval)
          return  
      }
      // if (search) {
          var height = search.split('=')[1]
          var doc = parent.parent.document
          var ifr = doc.getElementById('ifr')
          ifr.style.height = height + 'px'
          isSet = true
      // }
    }, 500)
  }
}
</script>
<style lang="scss">

</style>
